module.exports = __webpack_public_path__ + "media/images/icons/vip-769331f1dae7688ade9b6b7cc266444e.svg";